import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from './cms-actions';
import {exhaustMap, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {InformationUnitRestService} from '@core/modules/rest/informationunit/information-unit-rest.service';
import {InformationUnitModel} from '@core/modules/rest/informationunit/response/information-unit.model';
import {IndicationRestService} from '@core/modules/rest/indication/indication-rest.service';
import {OutlineUnitBasicModel} from '@core/modules/rest/consent/response/outline-unit-basic.model';

@Injectable()
export class CmsEffects {

    constructor(private actions$: Actions, private informationUnitService: InformationUnitRestService,
                private indicationService: IndicationRestService) {
    }

    getInformationUnit$ = createEffect(() => this.actions$
        .pipe(
            ofType(fromActions.GetInformationUnit),
            exhaustMap((action: ReturnType<typeof fromActions.GetInformationUnit>) => {
                return this.informationUnitService.getInformationUnitById(action.unitId)
                    .pipe(
                        map((response: InformationUnitModel) => fromActions.GetInformationUnitSuccess({
                            unit: response
                        }))
                    );
            })
        )
    );

    getCMSOutline$ = createEffect(() => this.actions$
        .pipe(
            ofType(fromActions.GetCMSOutline),
            exhaustMap((action: ReturnType<typeof fromActions.GetCMSOutline>) => {
                return this.indicationService.getCMSOutlineFlat(action.request)
                    .pipe(
                        map((response: OutlineUnitBasicModel[]) => fromActions.GetCMSOutlineSuccess({
                            outline: response
                        }))
                    );
            })
        )
    );

    saveInformationUnit$ = createEffect(() => this.actions$
        .pipe(
            ofType(fromActions.SaveInformationUnit),
            exhaustMap((action: ReturnType<typeof fromActions.SaveInformationUnit>) => {
                return this.informationUnitService.saveInformationUnit(action.saveUnitRequest)
                    .pipe(
                        map((response: InformationUnitModel) => {
                            action.executed(response);
                            return fromActions.SaveInformationUnitSuccess({unit: response});
                        })
                    );
            })
        )
    );

    moveUnitLevelDown$ = createEffect(() => this.actions$
        .pipe(
            ofType(fromActions.MoveUnitLevelDown),
            exhaustMap((action: ReturnType<typeof fromActions.MoveUnitLevelDown>) => {
                return this.indicationService.moveUnitLevelDown(action.request)
                    .pipe(
                        map((response: OutlineUnitBasicModel[]) => {
                            return fromActions.MoveUnitLevelDownSuccess({units: response});
                        })
                    );
            })
        )
    );

    moveUnitLevelUp$ = createEffect(() => this.actions$
        .pipe(
            ofType(fromActions.MoveUnitLevelUp),
            exhaustMap((action: ReturnType<typeof fromActions.MoveUnitLevelUp>) => {
                return this.indicationService.moveUnitLevelUp(action.request)
                    .pipe(
                        map((response: OutlineUnitBasicModel[]) => {
                            return fromActions.MoveUnitLevelUpSuccess({units: response});
                        })
                    );
            })
        )
    );

    reorderUnits$ = createEffect(() => this.actions$
        .pipe(
            ofType(fromActions.ReorderUnits),
            exhaustMap((action: ReturnType<typeof fromActions.ReorderUnits>) => {
                return this.indicationService.reorderUnits(action.request)
                    .pipe(
                        map((response: OutlineUnitBasicModel[]) => {
                            return fromActions.ReorderUnitsSuccess({units: response});
                        })
                    );
            })
        )
    );

    deleteInformationUnit$ = createEffect(() => this.actions$
        .pipe(
            ofType(fromActions.DeleteUnit),
            exhaustMap((action: ReturnType<typeof fromActions.DeleteUnit>) => {
                return this.informationUnitService.deleteInformationUnit(action.request)
                    .pipe(
                        map((response: OutlineUnitBasicModel[]) => {
                            return fromActions.DeleteUnitSuccess({units: response});
                        })
                    );
            })
        )
    );

    changeUnitRelevance$ = createEffect(() => this.actions$
        .pipe(
            ofType(fromActions.ChangeUnitRelevance),
            exhaustMap((action: ReturnType<typeof fromActions.ChangeUnitRelevance>) => {
                return this.indicationService.changeUnitRelevance(action.request)
                    .pipe(
                        map(() => {
                            return fromActions.ChangeUnitRelevanceSuccess();
                        })
                    );
            })
        )
    );
}
